import { trpc } from '../lib/trpc';

/**
 * サブスクリプション使用状況を取得するフック
 *
 * @returns 使用状況データとクエリ状態
 */
export function useSubscriptionUsage() {
  return trpc.subscriptionAddon.getUsage.useQuery(undefined, {
    // 1分ごとに自動リフレッシュ
    refetchInterval: 60000,
    // バックグラウンドでも更新
    refetchIntervalInBackground: false,
    // キャッシュを即座に古い状態として扱う（invalidate後に即座に再フェッチ）
    staleTime: 0,
  });
}
